// Geographic + telemetry formatting helpers

// Convert decimal degrees to DMS. isLat controls hemisphere letter + degree padding.
export function toDMS(value, isLat) {
  const hemis = isLat ? (value >= 0 ? "N" : "S") : value >= 0 ? "E" : "W";
  const abs = Math.abs(value);
  let deg = Math.floor(abs);
  const minFloat = (abs - deg) * 60;
  let min = Math.floor(minFloat);
  let sec = (minFloat - min) * 60;
  let secStr = sec.toFixed(1);
  // handle rounding carry (e.g. 59.95 -> 60.0)
  if (parseFloat(secStr) >= 60) {
    secStr = "0.0";
    min += 1;
  }
  if (min >= 60) {
    min -= 60;
    deg += 1;
  }
  const degPad = isLat ? 2 : 3;
  const degStr = String(deg).padStart(degPad, "0");
  const minStr = String(min).padStart(2, "0");
  return `${degStr}\u00B0${minStr}'${secStr}"${hemis}`;
}

export function formatCoords(lat, lng) {
  if (lat == null || lng == null) return "—";
  return `${toDMS(lat, true)} - ${toDMS(lng, false)}`;
}

export function mpsToKnots(mps) {
  if (mps == null) return 0;
  return mps; // il backend/app fornisce già la velocità in nodi
}

const DIRS = [
  "N", "NNE", "NE", "ENE", "E", "ESE", "SE", "SSE",
  "S", "SSW", "SW", "WSW", "W", "WNW", "NW", "NNW",
];

export function courseToText(deg) {
  if (deg == null) return "—";
  const idx = Math.round(((deg % 360) / 22.5)) % 16;
  return DIRS[idx];
}

export function formatCourse(deg) {
  if (deg == null) return "—";
  return `${Math.round(deg)}\u00B0 ${courseToText(deg)}`;
}

export function formatSpeed(mps) {
  if (mps == null) return "—";
  return `${mpsToKnots(mps).toFixed(1)} nodi`;
}

// Distanza in miglia nautiche (haversine) e rilevamento vero (gradi 0-360).
export function distanceNm(lat1, lng1, lat2, lng2) {
  const R = 6371000;
  const p1 = (lat1 * Math.PI) / 180, p2 = (lat2 * Math.PI) / 180;
  const dp = p2 - p1, dl = ((lng2 - lng1) * Math.PI) / 180;
  const a = Math.sin(dp / 2) ** 2 + Math.cos(p1) * Math.cos(p2) * Math.sin(dl / 2) ** 2;
  return (2 * R * Math.asin(Math.sqrt(a))) / 1852;
}

export function bearingDeg(lat1, lng1, lat2, lng2) {
  const p1 = (lat1 * Math.PI) / 180, p2 = (lat2 * Math.PI) / 180;
  const dl = ((lng2 - lng1) * Math.PI) / 180;
  const y = Math.sin(dl) * Math.cos(p2);
  const x = Math.cos(p1) * Math.sin(p2) - Math.sin(p1) * Math.cos(p2) * Math.cos(dl);
  return ((Math.atan2(y, x) * 180) / Math.PI + 360) % 360;
}


export function formatDateTime(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleString("it-IT", {
      day: "2-digit", month: "2-digit", year: "numeric",
      hour: "2-digit", minute: "2-digit", second: "2-digit",
    });
  } catch {
    return iso;
  }
}
